import { render, staticRenderFns } from "./CompBureauAdminStats.vue?vue&type=template&id=6913027b"
import script from "./CompBureauAdminStats.vue?vue&type=script&lang=js"
export * from "./CompBureauAdminStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports